<template>
  <div>
    <div class="breadcrumb-area pos-relative w-100">
      <h1>Danh sách xuất nhập thiết bị theo kho</h1>
      <div class="btn-group float-right">
        <DraggableTable
          :naming="$router.name"
          v-model="fieldsTableOrder"
          @change="filterTableOrder = $event"
        />
        <button class="font-medium f12 btn btn-outline-secondary" @click="exportExcel">
          <i class="bx bx-download"></i><span>&nbsp;</span>Xuất Excel
        </button>
      </div>
    </div>
    <div class="card p-10 pt-15 b-t-1-869fb229">
      <div class="card-header m-b-10">
        <form class="box-search" @submit.prevent="submitForm">
          <div class="form-group">
            <DateRangePicker
              class="w-100"
              :ranges="false"
              v-model="search.timeReport"
              :locale-data="Config.localeData"
            >
              <template v-slot:input="picker">
                <label
                  v-if="picker.startDate && picker.endDate"
                  style="min-width: 13.5em"
                  class="text-center font-size-12 pt-1"
                >
                  {{ picker.startDate | formatDate }} -
                  {{ picker.endDate | formatDate }}
                </label>
                <label v-else style="min-width: 13.5em" class="font-size-12 time-placeholder">
                  Thời gian (*)
                </label>
              </template>
            </DateRangePicker>
          </div>
          <div class="form-group">
            <Select2
              class="haha"
              v-model="search.inventoryId"
              :options="warehouseData"
              placeholder="Kho (*)"
            >
            </Select2>
          </div>
          <div class="form-group">
            <Select2
              v-model="search.type"
              :options="Config.typeReportInventory"
              placeholder="Phân loại (xuất/nhập) (*)"
            ></Select2>
          </div>
          <div class="form-group">
            <Select2
              v-model="search.categoryId"
              :options="optionCategory"
              placeholder="Tên thiết bị"
            ></Select2>
          </div>
          <div class="form-group form-group-action">
            <button type="button" class="btn btn-primary hc-37 mr-2 pt-2" @click="submitForm">
              <i class="bx bx-filter-alt"></i><span>&nbsp;</span>Lọc
            </button>
            <button type="button" class="btn btn-outline-light hc-37 mr-2 pt-2" @click="removeForm">
              <i class="bx bx-filter-alt"></i><span>&nbsp;</span>Bỏ lọc
            </button>
          </div>
        </form>
      </div>
      <div class="card-body">
        <div class="tab-content" id="nav-tabContent">
          <div v-if="this.listsOrder.length > 0" class="p-10">
            <h5>Dữ liệu tổng hợp</h5>
            <b-table
              :busy.sync="tbLoading"
              sticky-header
              responsive
              hover
              :items="listsOrder"
              :fields="filterTableOrder"
              :fixed="true"
              :bordered="true"
            >
              <template #table-busy>
                <div class="text-center my-2">
                  <b-spinner class="align-middle"></b-spinner>
                </div>
              </template>
            </b-table>
          </div>
          <div v-if="this.listsDevices.length > 0" class="p-10">
            <h5>Dữ liệu chi tiết</h5>
            <b-table
              :busy.sync="tbLoading"
              sticky-header
              responsive
              hover
              :items="listsDevices"
              :fields="filterTableDevice"
              :fixed="true"
              :bordered="true"
            >
              <template #table-busy>
                <div class="text-center my-2">
                  <b-spinner class="align-middle"></b-spinner>
                </div>
              </template>
            </b-table>
          </div>
        </div>
      </div>
    </div>
    <VueLoadingOverlay :active.sync="showLoading" :is-full-page="true"> </VueLoadingOverlay>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import 'vue-simple-suggest/dist/styles.css'
  import Config from '@/thirdParty/config'
  import moment from 'moment'
  import cloneDeep from 'lodash/cloneDeep'
  import { DeviceService } from '@/services/device.service'
  const fieldsTableOrder = [
    { key: 'categoryName', label: 'Tên thiết bị', thStyle: 'min-width: 170px' },
    { key: 'categoryCode', label: 'Tên rút gọn', thStyle: 'min-width: 170px' },
    { key: 'totalImport', label: 'SL Nhập', thStyle: 'min-width: 170px' },
    { key: 'totalExport', label: 'SL Xuất', thStyle: 'min-width: 170px' },
  ]
  const fieldsTableDevices = [
    { key: 'dateImExportConvert', label: 'Ngày', thStyle: 'min-width: 170px' },
    { key: 'categoryName', label: 'Tên thiết bị', thStyle: 'min-width: 170px' },
    { key: 'categoryCode', label: 'Tên rút gọn', thStyle: 'min-width: 170px' },
    { key: 'serial', label: 'Serial', thStyle: 'min-width: 170px' },
    { key: 'type', label: 'Nhập/Xuất', thStyle: 'min-width: 170px' },
    { key: 'inventoryNameImport', label: 'Kho Nhập', thStyle: 'min-width: 170px' },
    { key: 'inventoryNameExport', label: 'Kho Xuất', thStyle: 'min-width: 170px' },
    { key: 'reason', label: 'Lý do', thStyle: 'min-width: 170px' },
    { key: 'orderCode', label: 'Mã phiếu', thStyle: 'min-width: 170px' },
  ]
  export default {
    name: 'report-inventory',
    data() {
      return {
        Config,
        fieldsTableOrder,
        fieldsTableDevices,
        filterTableOrder: fieldsTableOrder,
        filterTableDevice: fieldsTableDevices,
        listsOrder: [],
        listsDevices: [],
        showLoading: false,
        tbLoading: false,
        search: {
          timeReport: {},
        },
        warehouseData: [],
        optionCategory: [],
      }
    },
    created() {
      this.fetchWarehouse()
      this.typeDeviceConfig()
    },
    computed: {
      ...mapGetters({
        dataPermission: 'role/dataPermission',
      }),
    },
    methods: {
      async submitForm() {
        this.fetchData()
      },
      async removeForm() {
        this.search = {
          timeReport: {
            startDate: null,
            endDate: null,
          },
        }
        this.listsDevices = []
        this.listsOrder = []
      },
      preareData() {
        const data = cloneDeep(this.search)
        if (data.timeReport.endDate) {
          data.dateFrom = moment(data.timeReport.startDate).startOf('day').valueOf()
          data.dateTo = moment(data.timeReport.endDate).endOf('day').valueOf()
        }
        if (data.categoryId === '0') delete data.categoryId
        if (data.inventoryId === '0') delete data.inventoryId
        delete data.timeReport
        return data
      },
      async fetchData() {
        try {
          this.showLoading = true
          this.tbLoading = true
          const params = this.preareData()
          const response = await DeviceService.fetchReportInventory(params)
          console.log(response.data)
          if (response.code === 1000) {
            this.listsOrder = response.data.orders
            this.listsDevices = response.data.devices
          } else {
            this.showFailMx(response.message)
          }
        } catch (error) {
          this.showFailMx(error.message)
        } finally {
          this.tbLoading = false
          this.showLoading = false
        }
      },
      async fetchWarehouse() {
        const response = await DeviceService.getListSearchWarehouse()
        const data = response.data.map(({ id, name }) => {
          return { id, text: name }
        })
        this.warehouseData = data
      },
      async exportExcel() {
        try {
          const params = this.preareData()
          this.showLoading = true
          await DeviceService.exportReportInventory(params)
        } catch (error) {
          console.log(error)
        } finally {
          this.showLoading = false
        }
      },
      async typeDeviceConfig() {
        try {
          const data = await DeviceService.typeDeviceConfig()
          if (data.success) {
            this.optionCategory = data.data.map(e => {
              return {
                id: e.id,
                text: e.name,
              }
            })
            this.optionCategory.unshift({ id: '0', text: 'Tất cả' })
          }
        } catch (error) {
          console.log(error)
        }
      },
    },
  }
</script>
<style scoped>
  .c-poiter {
    cursor: pointer;
  }
</style>
